import { createReduxAsyncThunk } from 'shared/utils';

import { driversAPI } from '../../api';

import { DRIVERS_STATE } from '../../constants';

import { GetDriverFuelAssignmentsFilter } from '../../types';

export const getDriverFuelAssignments = createReduxAsyncThunk(
  `${DRIVERS_STATE}/getDriverFuelAssignments`,
  async (filter: GetDriverFuelAssignmentsFilter) => {
    const { data } = await driversAPI.getDriverFuelAssignments(filter);
    return data;
  }
);
